import { useEffect, useRef, useState } from 'react';
import resolveApiBase from '../tradingCockpit/apiBase';

const API_BASE = resolveApiBase();
const API_KEY = process.env.REACT_APP_API_KEY;
const POLL_INTERVAL_MS = 30 * 1000;

const resolveUrl = (path) => {
    if (!API_BASE) {
        return path;
    }
    const normalisedBase = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
    return `${normalisedBase}${path.startsWith('/') ? path : `/${path}`}`;
};

const buildHeaders = () => {
    const headers = { Accept: 'application/json' };
    if (API_KEY) {
        headers['x-api-key'] = API_KEY;
    }
    return headers;
};

export const useStrategyPerformance = ({ rangeDays = 30 } = {}) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [refreshKey, setRefreshKey] = useState(0);
    const lastFetchRef = useRef(0);

    useEffect(() => {
        let cancelled = false;
        let timer = null;

        const fetchPerf = async () => {
            try {
                const response = await fetch(
                    resolveUrl(`/api/qcockpit/strategy-performance?days=${rangeDays}`),
                    { headers: buildHeaders() }
                );
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const payload = await response.json();
                if (cancelled) return;
                setData(payload);
                setError(null);
                lastFetchRef.current = Date.now();
            } catch (err) {
                if (cancelled) return;
                console.warn('strategy-performance fetch failed', err);
                setError(err);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        fetchPerf();
        timer = window.setInterval(fetchPerf, POLL_INTERVAL_MS);
        return () => {
            cancelled = true;
            if (timer) window.clearInterval(timer);
        };
    }, [rangeDays, refreshKey]);

    const refresh = () => setRefreshKey((k) => k + 1);

    return { data, error, loading, refresh, lastFetchAt: lastFetchRef.current };
};

export default useStrategyPerformance;
